import { createStyles, makeUiStyles, Theme } from '../styles/styles';
import { StylesIndexInjections } from 'common-react';

export interface ProfitLossBadgeStyleProps {
  isProfit: boolean;
  isZero: boolean;
}

export default makeUiStyles((theme: Theme) => createStyles({
    root: {
      display: 'inline-flex',
      alignItems: 'baseline',
      width: 'fit-content',
      padding: '2px 4px',
      borderRadius: 4,
      backgroundColor: ({ isProfit, isZero }: ProfitLossBadgeStyleProps) => {
        if (isZero) return 'transparent';
        return isProfit ? theme.color.greens[10] : theme.color.reds[10];
      },
    },
  }), { name: 'ProfitLossBadge', index: StylesIndexInjections.UI_MOLECULES });
